const module = { name: 'video/redbandVerification', exports: {} }; const exports = module.exports;



import { global_consts as global_consts_CookieNames } from 'require-core';

const { CookieNames } = global_consts_CookieNames;


import { Fandango_cookie as Fandango_cookie_get_getCookie_set_setCookie } from 'require-core';

const { get: getCookie, set: setCookie } = Fandango_cookie_get_getCookie_set_setCookie;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_Dialog as Dialog } from 'require-global';



const Selectors = {
    DIALOG: '#videoRedbandModal',
    CANCEL_BTN: '#videoRedbandModalCancel',
    YES_BTN: '#videoRedbandModalYes',
}


const COOKIE_DURATION = 60 * 60 * 1000


const COOKIE_VALUE_OK = 'true'


let dialog


let onCompleteCb
function onCancelBtnClick(e) {
    e.preventDefault();
    dialog.close();
    if (onCompleteCb) {
        onCompleteCb(false);
    }
    else {
        document.location = '//www.fandango.co.uk';
    }
}
function onYesBtnClick(e) {
    e.preventDefault();
    dialog.close();
    const expiry = new Date();
    expiry.setTime(expiry.getTime() + COOKIE_DURATION);
    setCookie(CookieNames.AGE_VERIFICATION, COOKIE_VALUE_OK, {
        expires: expiry,
        path: '/',
        domain: '.fandango.co.uk'
    });
    if (onCompleteCb) {
        onCompleteCb(true);
    }
}
function showModal(cb) {
    if (dialog) {
        onCompleteCb = cb;
        dialog.open();
    }
}
function isAgeOk() {
    return getCookie(CookieNames.AGE_VERIFICATION) === COOKIE_VALUE_OK;
}
function init() {
    if (isAgeOk()) {
        return;
    }
    const $dialog = $(Selectors.DIALOG);
    if (!$dialog.length) {
        return;
    }
    if (dialog) {
        return;
    }
    dialog = new Dialog(Selectors.DIALOG, {
        closeOnBgClick: false,
        closeOnEsc: false
    });
    $dialog.on('click', Selectors.YES_BTN, onYesBtnClick);
    $dialog.on('click', Selectors.CANCEL_BTN, onCancelBtnClick);
}
module.exports = {
    init,
    ageOk: isAgeOk,
    showAgeModal: showModal
};
export default module.exports;